export type SponsorshipBadgeTier = 'basic' | 'pro' | 'elite';

interface SponsoredBadgeProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  /** Only the Elite tier shows the star. */
  badgeTier?: SponsorshipBadgeTier;
}

const SponsoredBadge: React.FC<SponsoredBadgeProps> = ({
  onClick,
  className,
  badgeTier = 'basic',
}) => {
  const isElite = badgeTier === 'elite';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={isElite ? 'Featured sponsored listing' : 'Sponsored listing'}
      className={`inline-flex items-center gap-1 rounded-full bg-[#0CA7C1] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm transition-opacity hover:opacity-90 ${className ?? ''}`}
    >
      {isElite && <span aria-hidden>★</span>}
      Sponsored
    </button>
  );
};

export default SponsoredBadge;
